<div>
  <mat-card class="call-stream-card" appearance="outlined">
    <div class="call-stream-header">
      <span class="call-stream-title">Call Stream</span>
      <mat-icon class="call-stream-info-icon" color="primary">info_outline</mat-icon>
      <span class="call-stream-toolbar-actions">
        <button mat-icon-button matTooltip="Export to CSV" matTooltipPosition="below" (click)="exportToCsv()">
          @if (loading) {
          <mat-icon>
            <mat-spinner color="warn" diameter="20" />
          </mat-icon>
          }
          @if (!loading) {
          <mat-icon>cloud_download</mat-icon>
          }
        </button>
      </span>
    </div>
    <mat-card-content>
      <div class="call-stream-content">
        <table mat-table [dataSource]="dataSource" class="call-stream-table" multiTemplateDataRows
          [class.sorting-in-progress]="sortingInProgress">
          <!-- common start columns -->
          <ng-container matColumnDef="actionRequired">
            <th mat-header-cell *matHeaderCellDef class="sticky-header"></th>
            <td mat-cell *matCellDef="let row" [class.sorting-loading]="sortingInProgress">
              @if (row.callRecordings?.length > 0) {
              <mat-icon class="color-primary">volume_up</mat-icon>
              }
              @if (row.comments) {
              <mat-icon class="color-primary action-comment-icon">comment</mat-icon>
              }
              @if (row.actionRequired) {
              <mat-icon class="color-caution">report_problem</mat-icon>
              }
            </td>
          </ng-container>
          <ng-container matColumnDef="dispositionTimestamp">
            <th mat-header-cell *matHeaderCellDef class="sticky-header sortable-header"
              (click)="sortBy('dispositiontimestamp')">
              <div class="header-content">
                <span>Timestamp</span>
                <mat-icon class="sort-icon" *ngIf="getSortIcon('dispositiontimestamp')">{{
                  getSortIcon('dispositiontimestamp') }}</mat-icon>
              </div>
            </th>
            <td mat-cell *matCellDef="let row" [class.sorting-loading]="sortingInProgress"
              [matTooltip]="row.dispositionTimestamp | date : 'short'">{{ row.dispositionTimestamp | date : 'short' }}
            </td>
          </ng-container>
          <!-- inbound columns -->
          <ng-container matColumnDef="handleTime">
            <th mat-header-cell *matHeaderCellDef class="sticky-header sortable-header" (click)="sortBy('handletime')">
              <div class="header-content">
                <span>Duration</span>
                <mat-icon class="sort-icon" *ngIf="getSortIcon('handletime')">{{ getSortIcon('handletime') }}</mat-icon>
              </div>
            </th>
            <td mat-cell *matCellDef="let row" [class.sorting-loading]="sortingInProgress">{{ (row.handleTime / 1000) |
              sdElapsedTime }}</td>
          </ng-container>
          <ng-container matColumnDef="inboundRetailerCode">
            <th mat-header-cell *matHeaderCellDef class="sticky-header sortable-header"
              (click)="sortBy('retailercode')">
              <div class="header-content">
                <span>Retailer Code</span>
                <mat-icon class="sort-icon" *ngIf="getSortIcon('retailercode')">{{ getSortIcon('retailercode')
                  }}</mat-icon>
              </div>
            </th>
            <td mat-cell *matCellDef="let row" [class.sorting-loading]="sortingInProgress"
              [matTooltip]="row.retailerCode">{{ row.retailerCode }}</td>
          </ng-container>
          <ng-container matColumnDef="name">
            <th mat-header-cell *matHeaderCellDef class="sticky-header sortable-header" (click)="sortBy('firstname')">
              <div class="header-content">
                <span>Name</span>
                <mat-icon class="sort-icon" *ngIf="getSortIcon('firstname')">{{ getSortIcon('firstname') }}</mat-icon>
              </div>
            </th>
            <td mat-cell *matCellDef="let row" [class.sorting-loading]="sortingInProgress"
              [matTooltip]="row.firstName + ' ' + row.lastName">{{ row.firstName }} {{ row.lastName }}</td>
          </ng-container>
          <ng-container matColumnDef="vehicle">
            <th mat-header-cell *matHeaderCellDef class="sticky-header sortable-header" (click)="sortBy('vehicleyear')">
              <div class="header-content">
                <span>Vehicle</span>
                <mat-icon class="sort-icon" *ngIf="getSortIcon('vehicleyear')">{{ getSortIcon('vehicleyear')
                  }}</mat-icon>
              </div>
            </th>
            <td mat-cell *matCellDef="let row" [class.sorting-loading]="sortingInProgress"
              [matTooltip]="row.vehicleYear + ' ' + row.vehicleMake + ' ' + row.vehicleModel">{{ row.vehicleYear }} {{
              row.vehicleMake }} {{ row.vehicleModel }}</td>
          </ng-container>
          <!-- outbound columns -->
          <ng-container matColumnDef="type">
            <th mat-header-cell *matHeaderCellDef class="sticky-header">Disposition Type</th>
            <td mat-cell *matCellDef="let row" [class.sorting-loading]="sortingInProgress">{{ row.type }}</td>
          </ng-container>
          <ng-container matColumnDef="outboundRetailerCode">
            <th mat-header-cell *matHeaderCellDef class="sticky-header sortable-header"
              (click)="sortBy('retailercode')">
              <div class="header-content">
                <span>Retailer Code</span>
                <mat-icon class="sort-icon" *ngIf="getSortIcon('retailercode')">{{ getSortIcon('retailercode')
                  }}</mat-icon>
              </div>
            </th>
            <td mat-cell *matCellDef="let row" [class.sorting-loading]="sortingInProgress"
              [matTooltip]="row.retailerCode">{{ row.retailerCode }}</td>
          </ng-container>
          <ng-container matColumnDef="vin">
            <th mat-header-cell *matHeaderCellDef class="sticky-header sortable-header" (click)="sortBy('vin')">
              <div class="header-content">
                <span>VIN</span>
                <mat-icon class="sort-icon" *ngIf="getSortIcon('vin')">{{ getSortIcon('vin') }}</mat-icon>
              </div>
            </th>
            <td mat-cell *matCellDef="let row" [class.sorting-loading]="sortingInProgress" [matTooltip]="row.vin">{{
              row.vin }}</td>
          </ng-container>
          <ng-container matColumnDef="customerName">
            <th mat-header-cell *matHeaderCellDef class="sticky-header sortable-header" (click)="sortBy('firstname')">
              <div class="header-content">
                <span>Customer Name</span>
                <mat-icon class="sort-icon" *ngIf="getSortIcon('firstname')">{{ getSortIcon('firstname') }}</mat-icon>
              </div>
            </th>
            <td mat-cell *matCellDef="let row" [class.sorting-loading]="sortingInProgress"
              [matTooltip]="(row.lastName ? row.lastName : '') + (row.lastName && row.firstName ? ', ' : '') + (row.firstName ? row.firstName : '')">
              {{ row.lastName ? row.lastName : '' }}{{ row.lastName && row.firstName ? ', ' : '' }}{{ row.firstName ?
              row.firstName : '' }}</td>
          </ng-container>
          <ng-container matColumnDef="recallCodes">
            <th mat-header-cell *matHeaderCellDef class="sticky-header sortable-header" (click)="sortBy('recallcodes')">
              <div class="header-content">
                <span>Recall Code(s)</span>
                <mat-icon class="sort-icon" *ngIf="getSortIcon('recallcodes')">{{ getSortIcon('recallcodes')
                  }}</mat-icon>
              </div>
            </th>
            <td mat-cell *matCellDef="let row" [class.sorting-loading]="sortingInProgress"
              [matTooltip]="row.recallCodes">{{ row.recallCodes }}</td>
          </ng-container>
          <!-- common end columns -->
          <ng-container matColumnDef="dispositionName">
            <th mat-header-cell *matHeaderCellDef class="sticky-header sortable-header"
              (click)="sortBy('dispositionname')">
              <div class="header-content">
                <span>Outcome</span>
                <mat-icon class="sort-icon" *ngIf="getSortIcon('dispositionname')">{{ getSortIcon('dispositionname')
                  }}</mat-icon>
              </div>
            </th>
            <td mat-cell *matCellDef="let row" [class.sorting-loading]="sortingInProgress"
              [matTooltip]="row.dispositionName">{{ row.dispositionName }}</td>
          </ng-container>

          <ng-container matColumnDef="details">
            <td mat-cell *matCellDef="let row" [attr.colspan]="actualDisplayedColumns.length">
              @if (row.sessionId === expandedRowSessionId) {
              <div class="enhanced-detail-container">
                <!-- Session ID Section -->
                <div class="detail-section session-section">
                  <mat-icon class="section-icon">info</mat-icon>
                  <div class="section-content">
                    <div class="section-title">Session Information</div>
                    <div class="detail-item">
                      <span class="detail-label">Session ID:</span>
                      <span class="detail-value">{{ row.sessionId }}</span>
                    </div>
                  </div>
                </div>
                <!-- Notes Section -->
                @if (row.comments) {
                <div class="detail-section notes-section">
                  <mat-icon class="section-icon">note</mat-icon>
                  <div class="section-content">
                    <div class="section-title">Notes</div>
                    <div class="detail-notes-content">{{ row.comments }}</div>
                  </div>
                </div>
                }

                <!-- Call Recordings Section -->
                @if (row.callRecordings?.length) {
                <div class="detail-section recordings-section">
                  <mat-icon class="section-icon">headset</mat-icon>
                  <div class="section-content">
                    <div class="section-title">Call Recordings ({{ row.callRecordings.length }})</div>
                    <div class="recordings-list">
                      @for (recording of row.callRecordings; track recording; let i = $index) {
                      <div class="recording-item">
                        <mat-icon class="recording-icon">play_circle</mat-icon>
                        <span class="recording-label">Recording {{ i + 1 }}</span>
                        <a [href]="getCallRecordingUrl(recording)" class="recording-download-btn" mat-stroked-button
                          color="primary" target="_blank">
                          <mat-icon>download</mat-icon>
                          Download
                        </a>
                      </div>
                      }
                    </div>
                  </div>
                </div>
                }
              </div>
              }
            </td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="actualDisplayedColumns"></tr>
          <tr mat-row *matRowDef="let row; columns: actualDisplayedColumns" (click)="toggleRowExpansion(row)"
            [class.expanded-row]="expandedRowSessionId === row.sessionId">
          </tr>
          <tr mat-row *matRowDef="let row; columns: ['details']; when: isDetailRow" class="example-detail-row">
          </tr>

          @if (dataSource.data.length === 0) {
          <tr>
            <td colspan="7" class="empty-state">No call records found.</td>
          </tr>
          }
        </table>
      </div>
      <div class="call-stream-footer">
        <mat-paginator #paginator [pageSize]="20" class="custom-paginator">
        </mat-paginator>
      </div>
    </mat-card-content>
  </mat-card>
</div>